import Button from "../../Button";
import constants from "../../../constants";
import React, { useContext, useEffect, useState } from "react";
import TestDueHooks from "../../../Hooks/TestDueHooks";
import AlertContext from "../../../context/AlertContext";
import DownloadSvgIcon from "../../../Svg/DownloadSvgIcon";
import TestDueDate from "../../CommonComponents/TestDueDate";
import McqAndDescHooks from "../../../Hooks/McqAndDescHooks";
import RightArrowSvgIcon from "../../../Svg/RightArrowSvgIcon";
import WarningNoticeHooks from "../../../Hooks/WarningNoticeHooks";
import WarningNoticeSvgIcon from "../../../Svg/WarningNoticeSvgIcon";
import CompleteSvgIcon from "../../CommonComponents/CompleteSvgIcon";
import WarningNoticeBodySvgIcon from "../../../Svg/WarningNoticeBodySvgIcon";
import StudentTestPageHooks from "../../../Hooks/StudentTestPage/StudentTestPageHooks";
import IconButton from "../../CommonComponents/IconButton";
import { Modal } from "@mui/material";
import ExtentionRequestForm from "./ExtentionRequestForm";
import Toast from "../../CommonComponents/Toast";
import Slide from "@mui/material/Slide";

const GetIssueStatus = ({ value }) =>
  Object.entries(constants.ISSUE_STATUS).map(
    (data, index) =>
      data[1] === value && (
        <p key={index} className={data[0]?.toLowerCase()}>
          {data[0]?.toLowerCase()}
        </p>
      )
  );

export const columns = [
    { key: "sno", title: "S.No", className: "serialNo" },
    { key: "typename", title: "Issue Type", className: "issueType" },
    { key: "bname", title: "Batch", className: "batch" },
    {
      key: "title",
      title: "Issue Title",
      className: "issueTitle",
    },
    {
      key: "description",
      title: "Description",
      className: "description",
    },
    {
      key: "status",
      title: "Status",
      className: "status",
      render: (value, row) => <GetIssueStatus value={value} />,
    },
  ],
  initialDetails = {
    title: "",
    type: null,
    bid: null,
    description: "",
    attachment: null,
  };

export default function WarningNotice() {
  const Alert = useContext(AlertContext);

  const { viewTest } = McqAndDescHooks();
  const { resetTest } = StudentTestPageHooks();
  const { currentDueLabel } = TestDueHooks();
  const WarningNoticeHks = WarningNoticeHooks();

  const [showForm, setShowForm] = useState(false);
  const [details, setDetails] = useState(initialDetails);
  const [selectedBatch, setSelectedBatch] = useState({});
  const [selectedType, setSelectedType] = useState({});
  const [isSuccess, setIsSuccess] = useState(false);
  const [toastMessage, setToastMessage] = useState({
    message: "",
    icon: (
      <svg
        width="46"
        height="46"
        viewBox="0 0 46 46"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect x="3" y="3" width="40" height="40" rx="20" fill="#D1FADF" />
        <rect
          x="3"
          y="3"
          width="40"
          height="40"
          rx="20"
          stroke="#ECFDF3"
          strokeWidth="6"
        />
        <g clip-path="url(#clip0_1393_14704)">
          <path
            d="M20.5003 23L22.167 24.6667L25.917 20.9167M19.1118 16.1822C19.7817 16.1288 20.4176 15.8654 20.929 15.4295C22.1226 14.4124 23.8781 14.4124 25.0716 15.4295C25.5831 15.8654 26.219 16.1288 26.8889 16.1822C28.452 16.307 29.6933 17.5483 29.8181 19.1115C29.8715 19.7813 30.1349 20.4173 30.5708 20.9287C31.5879 22.1223 31.5879 23.8777 30.5708 25.0713C30.1349 25.5827 29.8715 26.2187 29.8181 26.8885C29.6933 28.4517 28.452 29.693 26.8889 29.8178C26.219 29.8712 25.5831 30.1346 25.0716 30.5705C23.8781 31.5876 22.1226 31.5876 20.929 30.5705C20.4176 30.1346 19.7817 29.8712 19.1118 29.8178C17.5486 29.693 16.3073 28.4517 16.1826 26.8885C16.1291 26.2187 15.8657 25.5827 15.4298 25.0713C14.4127 23.8777 14.4127 22.1223 15.4298 20.9287C15.8657 20.4173 16.1291 19.7813 16.1826 19.1115C16.3073 17.5483 17.5486 16.307 19.1118 16.1822Z"
            stroke="#039855"
            strokeWidth="1.66667"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_1393_14704">
            <rect
              width="20"
              height="20"
              fill="white"
              transform="translate(13 13)"
            />
          </clipPath>
        </defs>
      </svg>
    ),
  });

  function SlideTransition(props) {
    return <Slide {...props} direction="left" />;
  }
  const [toastOpen, setToastOpen] = useState({
    open: false,
    vertical: "top",
    horizontal: "center",
    Transition: SlideTransition,
  });

  const isEdit = details?.id && Number.isInteger(Number(details?.id));

  const onCloseForm = () => {
    setShowForm(false);
    setDetails(initialDetails);
    setSelectedBatch({});
    setSelectedType({});
  };

  const handleClose = (event, reason) => {
    setToastOpen({
      ...toastOpen,
      open: false,
    });
  };

  // console.log("toastMessage:",toastMessage);

  const { vertical, horizontal, open, Transition } = toastOpen;

  useEffect(() => {}, [Alert.VideoSaved]);
  
  return (
    <div className={WarningNoticeHks.getMainDivClassNameForWarningNotice()}>
      {WarningNoticeHks.showCompleteSvgIcon() ? (
        <CompleteSvgIcon />
      ) : (
        <WarningNoticeSvgIcon />
      )}
      <div className="warningNoticeInfo">
        <div className="warningNoticeInfoHeader">
          {Alert.status !== constants.PROGRESS_STATUS.EVALUATED &&
          Alert.lpData.batchType !== constants.BATCH_TYPE.SELF &&
          currentDueLabel(Alert.testData.duedate) === "Past Due" &&
          Alert.status !== constants.PROGRESS_STATUS.TO_BE_EVALUATED &&
          Alert.status !== constants.PROGRESS_STATUS.PARTIAL_EVALUATED
            ? WarningNoticeHks.currentTestDue(
                Alert.testData.libtype !== null
                  ? Alert.testData.libtype
                  : Alert.testData.testtype
              )
            : WarningNoticeHks.showWarningForAssessment()
            ? Alert.isVersionUpToDate
              ? "The test needs to be taken in latest version of Gradious LEAP Desktop Application."
              : "The test needs to be taken in Gradious LEAP Desktop Application."
            : Alert.status === constants.PROGRESS_STATUS.IN_PROGRESS
            ? "Contact Trainer"
            : Alert.status === constants.PROGRESS_STATUS.QN_CONTINUE
            ? "The test had a problem, you can resume it."
            : Alert.status === constants.PROGRESS_STATUS.REATTEMPT
            ? "The trainer has asked you to retake the test"
            : (Alert.status === constants.PROGRESS_STATUS.EVALUATED ||
                Alert.status === constants.PROGRESS_STATUS.TO_BE_EVALUATED ||
                Alert.status ===
                  constants.PROGRESS_STATUS.PARTIAL_EVALUATED) && (
                <div>
                  Completed
                  <p className="warningNoticeInfoHeaderSubText">
                    You've completed this test, you can go to the next available
                    test/chapter.
                  </p>
                </div>
              )}
        </div>
        <div className="warningNoticeInfoBody">
          {Alert.status !== constants.PROGRESS_STATUS.EVALUATED &&
          Alert.lpData.batchType !== constants.BATCH_TYPE.SELF &&
          currentDueLabel(Alert.testData.duedate) === "Past Due" &&
          Alert.status !== constants.PROGRESS_STATUS.TO_BE_EVALUATED &&
          Alert.status !== constants.PROGRESS_STATUS.PARTIAL_EVALUATED ? (
            <>
              The due date for the{" "}
              {WarningNoticeHks.currentTestDue(
                Alert.testData.libtype !== null
                  ? Alert.testData.libtype
                  : Alert.testData.testtype,
                "name"
              )}{" "}
              has crossed. Request your trainer to extend the due date.
              <div className="warningNoticeInfoBodyDivText">
                If your trainer extends, you can complete the{" "}
                {WarningNoticeHks.currentTestDue(
                  Alert.testData.libtype !== null
                    ? Alert.testData.libtype
                    : Alert.testData.testtype,
                  "test"
                )}
                .
              </div>
              {localStorage.getItem("batchType") == constants.BATCH_TYPE.LEARNING && (
                <Button
                  size="sm"
                  onClick={() => setShowForm(true)}
                  hierarchy={{
                    type: "primary",
                    buttonText: "Request Extension",
                  }}
                />
              )}
            </>
          ) : WarningNoticeHks.showWarningForAssessment() ? (
            Alert.isVersionUpToDate ? (
              <>
                <div className="warningNoticeInfoBodyDivText">
                  We do not allow tests to be taken in this version due to
                  unsupported features. Please download and install the updated
                  version to begin your test.
                </div>
                <div className="warningNoticeInfoBodyBtnDiv">
                  <Button
                    size="sm"
                    icon={{ type: "trailing", icon: <RightArrowSvgIcon /> }}
                    onClick={() =>
                      (window.location.href = WarningNoticeHks.downloadApp())
                    }
                    hierarchy={{ type: "primary", buttonText: "Download Now" }}
                  />
                </div>
              </>
            ) : (
              <>
                We do not allow tests to be taken in a web browser due to
                unsupported features.
                <div className="warningNoticeInfoBodyDivText">
                  Please open the Gradious LMS application you've already
                  downloaded to begin your test.
                </div>
                <div className="warningNoticeInfoBodyBtnDiv">
                  <Button
                    size="sm"
                    icon={{ type: "trailing", icon: <RightArrowSvgIcon /> }}
                    onClick={() => (window.location.href = "gradious-lms://")}
                    hierarchy={{ type: "primary", buttonText: "Open App" }}
                  />
                  <Button
                    size="sm"
                    icon={{
                      type: "leading",
                      icon: <DownloadSvgIcon component="warning" />,
                    }}
                    onClick={() =>
                      (window.location.href = WarningNoticeHks.downloadApp())
                    }
                    hierarchy={{
                      type: "secondaryGrey",
                      buttonText: "Download Now",
                    }}
                  />
                </div>
              </>
            )
          ) : Alert.status === constants.PROGRESS_STATUS.QN_CONTINUE ? (
            <>
              There has been an issue in your test. This can be for multiple
              reasons. You can talk to our team for the exact issue.
              <div className="warningNoticeInfoBodyDivText">
                You will be allowed to take the test from where you left.
              </div>
            </>
          ) : Alert.status === constants.PROGRESS_STATUS.REATTEMPT ? (
            <>
              You need to take the test again as the trainer has asked to. This
              can be for multiple reasons. You can talk to our team for the
              exact issue.
              <div className="warningNoticeInfoBodyDivText">
                Your older attempt will be deleted and this new attempt will be
                considered.
              </div>
            </>
          ) : Alert.status === constants.PROGRESS_STATUS.IN_PROGRESS ? (
            <>
              We encountered an issue in your test. It can be for multiple
              reasons:
              <ul className="warningNoticeInfoBodyUnorderedList">
                <li>You left the test page by mistake.</li>
                <li>You were glancing away from this screen.</li>
                <li>
                  We couldn't proctor you because your face wasn't visible.
                </li>
              </ul>
              <div className="warningNoticeInfoBodyDivText">
                You can talk to our team for the exact issue. If your trainer
                extends, you can complete the test.
              </div>
            </>
          ) : (
            (Alert.status === constants.PROGRESS_STATUS.EVALUATED ||
              Alert.status === constants.PROGRESS_STATUS.TO_BE_EVALUATED ||
              Alert.status === constants.PROGRESS_STATUS.PARTIAL_EVALUATED) && (
              <div className="submissionDetail">
                <div className="submissionDetailHeader">
                  <div className="submissionDetailHeaderField">
                    Status
                    <span className="submissionDetailHeaderFieldColon">:</span>
                  </div>
                  {Alert.testData.viewtest ===
                    constants.DISPLAY_TEST_RESULT.SCORE && (
                    <div className="submissionDetailHeaderSubField">
                      Score
                      <span className="submissionDetailHeaderFieldColon">
                        :
                      </span>
                    </div>
                  )}
                  <div className="submissionDetailHeaderSubField">
                    Submission Date
                    <span className="submissionDetailHeaderFieldColon">:</span>
                  </div>
                </div>
                <div className="submissionDetailValue">
                  {Alert.testData.viewtest !==
                  constants.DISPLAY_TEST_RESULT.SCORE
                    ? `${
                        Alert.testData.videoqn &&
                        Alert.qnTrack.current !== Alert.VideoSaved
                          ? `Video upload inprogress (${
                              Alert.VideoSaved + "/" + Alert.qnTrack.current
                            })`
                          : "Submitted"
                      }`
                    : "Evaluated"}
                  {Alert.testData.viewtest ===
                    constants.DISPLAY_TEST_RESULT.SCORE && (
                    <div className="submissionDetailFieldValue">
                      {Alert.testData.actualscore}/
                      {Alert.testData.configdata.marks}
                    </div>
                  )}
                  <div className="submissionDetailFieldValue">
                    <TestDueDate component="warningNotice" />
                  </div>
                  {(Alert.testData.viewtest ===
                    constants.DISPLAY_TEST_RESULT.SUBMISSION ||
                    Alert.testData.viewtest ===
                      constants.DISPLAY_TEST_RESULT.ALL) && (
                    <>
                      <div className="submissionDetailValueButton">
                        <Button
                          size={"sm"}
                          onClick={() => {
                            viewTest();
                          }}
                          disable={Alert.buttonDisable}
                          hierarchy={{
                            type: "secondaryGrey",
                            buttonText: "View Answers",
                          }}
                        />
                      </div>
                      {Alert.testData.testmode ===
                        constants.MODE.PRACTICE_MODE && (
                        <div className="submissionDetailRetakeValueButton">
                          {/* handling practice retake*/}

                            <Button
                              size={"sm"}
                              onClick={() => {
                                resetTest();
                              }}
                              hierarchy={{
                                buttonText: "Retake",
                                type: "secondaryColor",
                              }}
                            />
                        </div>
                      )}
                    </>
                  )}
                </div>
              </div>
            )
          )}
        </div>
      </div>
      {!WarningNoticeHks.showCompleteSvgIcon() ? (
        <WarningNoticeBodySvgIcon />
      ) : (
        <div className="warningNoticeSubmissionButton">
          <Button
            size={"sm"}
            onClick={WarningNoticeHks.goToNextTest}
            icon={{ type: "trailing", icon: <RightArrowSvgIcon /> }}
            hierarchy={{
              type: "primary",
              buttonText: "Next  ",
            }}
          />
        </div>
      )}
      {/* {formOpen && (
        // <form>
        //   <label>Enter your name:<input type="text"/></label>
        // </form>

      )} */}
      <Toast
        open={open}
        onClose={handleClose}
        message={toastMessage.message}
        autoHideDuration={6000}
        icon={toastMessage.icon}
        closeIcon={
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M15 5L5 15M5 5L15 15"
              stroke="#667085"
              stroke-width="1.66667"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        }
        anchorOrigin={{ vertical, horizontal }}
        key={vertical + horizontal}
        TransitionComponent={Transition}
      />
      <Modal open={showForm} className="raisedIssueFormModalContainer">
        <div className="raisedIssueFormModal">
          <div className="raisedIssueFormHeader">
            <div className="modalTitle">Extension Request</div>
            <div className="modalCloseIcon">
              <IconButton
                onClick={onCloseForm}
                size="sm"
                hierarchy="tertiaryGrey"
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M15 5L5 15M5 5L15 15"
                    stroke="#667085"
                    strokeWidth="1.66667"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </IconButton>
            </div>
          </div>

          <ExtentionRequestForm
            setShowForm={setShowForm}
            isEdit={isEdit}
            lpData={Alert.lpData}
            contentData={Alert.contentData}
            details={details}
            setDetails={setDetails}
            selectedBatch={selectedBatch}
            setSelectedBatch={setSelectedBatch}
            selectedType={selectedType}
            setSelectedType={setSelectedType}
            initialDetails={initialDetails}
            setIsSuccess={setIsSuccess}
            setToastOpen={setToastOpen}
            SlideTransition={SlideTransition}
            toastMessage={toastMessage}
            setToastMessage={setToastMessage}
          />
        </div>
      </Modal>
    </div>
  );
}
